import { RefreshCwIcon } from 'lucide-react';

import { Button } from '@@/ui/primitives';
import { EntityRecord } from '../../../../api/api-entities';
import { ItemEditorSheet } from '../../../../components/item-editor/item-create-sheet';

export function ItemToolbar(props: { entity: EntityRecord }) {
  const handleRefresh = () => {
    console.log('Refresh configurations');
  };

  return (
    <div className='flex items-center gap-3 right-0'>
      <div className='flex items-center'>
        <Button variant='ghost' size='sm' onClick={handleRefresh} title='Refresh' className='text-sm!' disabled>
          <RefreshCwIcon className='size-4' />
        </Button>
      </div>
      {props.entity.entityId !== 'root' && <ItemEditorSheet entity={props.entity} />}
    </div>
  );
}
